<template>
  <!-- table -->
  <div class="table-wrap">
    <el-table
        :data="tableData"
        style="width:100%; margin-bottom: 20px;"
        border
        :cell-style="{'text-align':'center'}">
      <el-table-column v-for="item in tableImg" :key="item.prop" :label="item.label">
        <template slot-scope="scope" >
          <img :src="scope.row['HEARDIMAGES'] == null ? '未上传' : scope.row['HEARDIMAGES']">
        </template>
      </el-table-column>
      <el-table-column v-for="item in tableLabel" :key="item.prop" :label="item.label">
        <template slot-scope="scope">
          <div style="margin-left: 10px" v-if="item.prop === 'CONTENT'">
            <div class="news-content">{{ scope.row[item.prop] }}</div>
          </div>
          <div style="margin-left: 10px" v-else="item.prop">{{ scope.row[item.prop] }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140px">
        <template slot-scope="scope">
          <div class="handle-btn"><el-button @click="handleEdit(scope.row.ID)" type="primary">编辑</el-button></div>
          <div class="handle-btn"><el-button @click="handleDelete(scope.row.ID)" type="danger">删除</el-button></div>
        </template>
      </el-table-column>
      <!-- 只在新闻表格显示-->
      <el-table-column label="设置热门" width="140px" v-if="tableType === 'news'">
        <template slot-scope="scope">
          <div class="handle-btn" v-if="scope.row.ISHOT === '0'"><el-button type="primary" @click="handleSetHot(scope.row.ID,scope.row.ISHOT)">设置</el-button></div>
          <div class="handle-btn" v-else><el-button type="danger" @click="handleSetHot(scope.row.ID,scope.row.ISHOT)">取消</el-button></div>
        </template>
      </el-table-column>
      <el-table-column label="排序" width="100px" v-if="(tableType === 'news' || tableType === 'person')">
        <template slot-scope="scope">
          <div class="sort-btn" v-if="(scope.$index !== 0 || tableData.length === 1)"><i class="el-icon-top" @click="handleUpSort(scope.row.ID)"></i></div>
          <div class="sort-btn" v-if="scope.$index !== (tableData.length - 1)"><i class="el-icon-bottom" @click="handleDownSort(scope.row.ID)"></i></div>
        </template>
      </el-table-column>
      <!-- 只在新闻表格显示-->
      <!-- 只在文档表格显示-->
      <el-table-column label="排序" width="100px" v-if="tableType === 'document'">
        <template slot-scope="scope">
          <div class="handle-btn">
            <el-link :href="scope.row.FILEURL">
              <el-button type="primary">下载</el-button>
            </el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'newsList',
  props: {
    tableData: {
      type: Array,
      default () {
        return []
      }
    },
    tableLabel: {
      type: Array,
      default () {
        return []
      }
    },
    tableImg: {
      type: Array,
      default () {
        return []
      }
    },
    activeName: {
      type: String,
      default () {
        return ''
      }
    },
    tableType: {
      type: String,
      default () {
        return ''
      }
    }
  },
  methods: {
    handleEdit (newsId) {
      this.$emit('edit', newsId)
    },
    // 删除新闻
    handleDelete (newsId) {
      this.$emit('delete', newsId)
    },
    handleRecommend (val) {
      this.$emit('recommend', val)
    },
    // 排序
    handleUpSort (newsId) {
      this.$emit('upSort', newsId)
    },
    handleDownSort (newsId) {
      this.$emit('downSort', newsId)
    },
    // 设置热门
    handleSetHot (newsId, ishot) {
      this.$emit('setHot', newsId, ishot)
    },
    handleDownload (url) {
      console.log('文档下载地址', url)
    }
  }
}
</script>

<style scoped>
.news-content{
  max-height: 300px;
  overflow-y: scroll;
}
.sort-btn{
  margin:6px 0;
}
.sort-btn i{
  font-size: 32px;
  color: #409EFF;
  font-weight: bold;
}
.handle-btn{
  margin:6px 0
}
</style>


// WEBPACK FOOTER //
// widghtNews.vue?1cd2f212